import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { LoanApi } from "../../../../../services/Api/types";

interface Props {
	loan: LoanApi;
	admin?: boolean;
}

const LoanPreviewBasicInfoCard = ({ loan, admin }: Props) => {
	const { t } = useTranslation("admin");

	const getRedirectToOrganization = () => {
		if (admin) {
			return `/admin/organizations/${loan.organization?.id}`;
		}
		return `/partnership/${loan.partner?.id}/organizations/${loan.organization?.id}`;
	};

	return (
		<Card className={"mb-3"}>
			<Card.Body>
				<h5>{t("common.word.basic_data", { ns: "lib" })}</h5>
				<div className="card-body-item">
					<div className="item-info">
						<span className="label">{t("common.word.reference_id")}</span>
						<span>{loan.reference_id}</span>
					</div>
				</div>
				<div className="card-body-item">
					<div className="item-info">
						<span className="label">{t("lib:common.word.location")}</span>
						<span>
							<Link to={getRedirectToOrganization()} target={"_blank"}>
								{loan.organization?.name}
							</Link>
						</span>
					</div>
				</div>
				<div className="card-body-item">
					<div className="item-info">
						<span className="label">{t("common.word.partner")}</span>
						<span>
							<Link to={`/partnership/${loan.partner?.id}/`} target={"_blank"}>
								{loan.partner?.name}
							</Link>
						</span>
					</div>
				</div>
				<div className="card-body-item">
					<div className="item-info">
						<span className="label">{t("common.word.license_type")}</span>
						<span>{loan.license_level}</span>
					</div>
				</div>
				{loan.start_at && (
					<div className="card-body-item">
						<div className="item-info">
							<span className="label">{t("modules.loan.field.start_at.title")}</span>
							<span>{FormatDate(loan.start_at).split(",")[0]}</span>
						</div>
					</div>
				)}
				{loan.cancellation_reason && (
					<div className="card-body-item">
						<div className="item-info">
							<span className="label">{t("modules.loan.field.cancellation_reason.title")}</span>
							<span>{loan.cancellation_reason}</span>
						</div>
					</div>
				)}
				{loan.cancelled_at && (
					<div className="card-body-item">
						<div className="item-info">
							<span className="label">{t("common.word.cancelled_at")}</span>
							<span>{FormatDate(loan.cancelled_at)}</span>
						</div>
					</div>
				)}
			</Card.Body>
		</Card>
	);
};

export default LoanPreviewBasicInfoCard;
